import Product = FBInstant.Product;
import { ItemIDs } from '../../../../Config/Items';
import { ShopCatalog, ShopProductIDs } from '../../../../Config/Shop';
import Core from '../../../../Core/Core';
import { createOutlineText, scaleToFit } from '../../../../Utils/Utils';
import { UIButton } from '../../../Shared/Buttons/UIButton';
import { HighlightEffect } from '../../../Shared/HighlightEffect';
import { ItemsList } from './ItemsList';
import { ShopProduct } from './ShopProduct';
import { TextButton } from '../../../Shared/Buttons/TextButton';

export class BigProduct extends ShopProduct {
    constructor(product: Product) {
        super(product);
        //@ts-ignore
        let key = Object.values(ShopProductIDs).indexOf(product.productID) + 1;
        const tint = ShopCatalog[product.productID as ShopProductIDs].tint || null;
        const bgSuffix = tint ? 'grey' : key;
        const bg = (this.bg = new PIXI.Sprite(
            PIXI.utils.TextureCache[`commonui/shop-bg-${bgSuffix}`]
        ));
        bg.anchor.set(0.5);
        if (tint) {
            bg.tint = tint;
        }
        const icon = new PIXI.Sprite(PIXI.utils.TextureCache[`commonui/shop-pack-${key}`]);
        icon.anchor.set(0.5);
        const rays = new HighlightEffect({ texture: 'commonui/shop-rays', duration: 7 });
        icon.x = rays.x = bg.width * 0.25;
        rays.appear();
        const buyButton = new TextButton({
            btnText: product.price,
            width: bg.width / 3,
            height: bg.height,
        });
        buyButton.x = bg.width * 0.47 - buyButton.width / 2;
        buyButton.y = bg.height * 0.47 - buyButton.height / 2;
        buyButton.on(UIButton.events.Trigger, this.buy.bind(this));

        const title = createOutlineText(
            Core.local.getText(product.productID),
            new PIXI.Rectangle(0, 0, bg.width, bg.height * 0.25),
            'Baloo'
        );
        title.anchor.set(0.5, 0);
        // title.x = -bg.width * 0.47;
        title.y = -bg.height * 0.47;

        const items = ShopCatalog[product.productID as ShopProductIDs].items;

        const coins = items.find(x => x.id === ItemIDs.COINS);

        const itemWidth = bg.width;
        const itemHeight = bg.height / 6;

        const coinIcon = new PIXI.Sprite(
            PIXI.utils.TextureCache[`commonui/shop_icon_${coins.id.toLowerCase()}`]
        );
        coinIcon.anchor.set(0.5);
        const text = createOutlineText(
            `x${coins.val}`,
            new PIXI.Rectangle(0, 0, itemWidth, itemHeight),
            'Baloo'
        );
        text.scale.set(scaleToFit(text.width, text.height, itemWidth, itemHeight));
        coinIcon.scale.set(scaleToFit(coinIcon.width, coinIcon.height, text.width, text.height));

        const container = new PIXI.Container();
        text.x = coinIcon.width * 0.4 + text.width / 2;
        container.addChild(coinIcon, text);

        const itemsList = new ItemsList(
            items.filter(x => x.id !== ItemIDs.COINS),
            bg.height * 0.5,
            itemWidth,
            itemHeight
        );
        container.x = -bg.width * 0.23 - container.width / 2;
        itemsList.x = -bg.width * 0.23 - itemsList.width / 2;
        container.y = -bg.height * 0.19 + container.height / 2;
        itemsList.y = container.y + container.height / 2;

        this.addChild(bg, rays, title, icon, buyButton, container, itemsList);
    }
}
